import { render, staticRenderFns } from "./Snoing.vue?vue&type=template&id=6d28c815&scoped=true"
import script from "./Snoing.vue?vue&type=script&lang=js"
export * from "./Snoing.vue?vue&type=script&lang=js"
import style0 from "./Snoing.vue?vue&type=style&index=0&id=6d28c815&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28c815",
  null
  
)

export default component.exports